import { id } from '../libraries/utils';

const routes = {

  ROUTES: {
    HOME: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    SIGNUP_FULL: '/social/signup',
    FORGOT: '/forgot',
    VERIFY: '/verify/:hash',
    PASSWORD: '/password/:hash',
 
    USER: {
      PASSWORD_CHANGE: '/user/change',
      PROFILE: '/user/profile',
      INFO: '/user/info',
    },

    HELP: '/help',
    PRIVACY: '/privacy',
    TERMS: '/terms',
    HOW_WORKS: '/how_works',
    CONTACT_US: '/contact_us',
    SUCCESS: '/success',
    VERIFY_PRESCRIPTION: '/verify_prescription/:id',

    APPOINTMENTS: {
      LIST: '/appointments',
      DETAIL: '/appointments/:id',
      CALL: '/appointments/:id/call',
      SUCCESS: '/appointments/:id/success',
    },


    PURCHASES: {
      LIST: '/purchases',
      DETAIL: '/purchases/:id',

      CART: '/cart',
      REVIEW: '/cart/review',
      SEARCH: '/cartsearch',
    },  

    PRESCRIPTIONS: '/prescriptions',
    PRESCRIPTION: '/prescriptions/:id',

    MESSAGES: '/messages',
    CHAT: '/messages/chat/:root_id',
    CREATE_MESSAGE:'/message/:professional_id',
    NOTIFICATIONS: '/notifications',

    PROFESSIONALS: '/professionals',
    PROFESSIONAL: '/professionals/:id',
    PHARMACIES: '/pharmacies',
    PHARMACY: '/pharmacies/:id',

    HISTORY: '/history',

    // PHARMACY: {
    //   ADD: '/pharmacy/add',
    // },    

    BOOKING: {
      TYPE: '/booking/type',
      CALENDAR: '/booking/calendar',
      CLINIC_HISTORY: '/booking/history',
      SUCCESS: '/booking/success',
    },

    BOOK_PRESCRIPTION: {
      PHARMACY: '/book_prescription/pharmacy',
      REVIEW: '/book_prescription/review',
      SUCCESS: '/book_prescription/success',
    },

    BOOK: {
      TIME: '/book/time',
      REVIEW: '/book/review',
      SUCCESS: '/book/success',
    },

    VERIFICATION: '/verification/questions',
    SIGNUP_VERIFICATION: '/verification/1',
    SIGNUP_VERIFICATION2: '/verification/2',
    SIGNUP_VERIFICATION_PREREGISTER: '/verification/2/:hash',

  },
};
export default routes;
